import React from "react";
import ControlDetailsPanel from "./ControlDetailsPanel";
import { IControlClimate } from "../types";
import ClimateTemperatureChart from "./ClimateTemperatureChart";
import ClimateHumidityChart from "./ClimateHumidityChart";
import ClimatePressureChart from "./ClimatePressureChart";

interface IControlDetailsClimateProps {
  control: IControlClimate;
}

const ControlDetailsClimate = (props: IControlDetailsClimateProps) => {
  const { control } = props;
  return (
    <ControlDetailsPanel
      mode={control.is_enabled ? "on" : "disabled"}
      title={control.name}
    >
      <ClimateTemperatureChart control={control} width={300} height={100} />
      <ClimateHumidityChart control={control} width={300} height={80} />
      <ClimatePressureChart control={control} width={300} height={80} />
    </ControlDetailsPanel>
  );
};

export default ControlDetailsClimate;
